// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"74":"907ecd84","140":"b9e62eb0","187":"a1ba38dd","235":"b222537d","260":"3c51b7f6","315":"fce7b0af","323":"b3c0fcd6","355":"efde494d","370":"b7a75406","407":"b37c95de","425":"50bf3a84","516":"1a43ab39","615":"977c6d54","934":"c8d3b0b6"}[chunkId] + ".js";
};